import React, { useState, useCallback, useContext, useEffect, useMemo, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Layout, Menu } from "antd";
import { getMenuListFromPermission } from '@/routes';
import { PermissionCtx } from "@/store/context";

export default function MenuLayout() {
    const navigate = useNavigate();
    const [items, setItems] = useState([])
    const itemMap = useRef({})

    const { routerArr } = useContext(PermissionCtx);
    useEffect(() => {
        const { itemList, listItemMap } = getMenuListFromPermission(routerArr)
        setItems(itemList)
        itemMap.current = listItemMap
    }, [routerArr])

    const showItems = useMemo(() => {
    }, [items])

    return (
        <Layout.Sider
            width={120}
            style={{
                paddingTop: 48,
                position: 'fixed',
                top: 0,
                left: 0,
                zIndex: 100,
                height: '100%',
            }}>
            <Menu
                theme="dark"
                // defaultSelectedKeys={['index']} // todo
                mode="inline"
                items={items}
                onClick={i => {
                    navigate(itemMap.current[i.key].path);
                }}
            />
        </Layout.Sider>
    );
}
